export interface NativeOCRFront {
  /** 民族 */
  nationality: string;
  /** 性别 */
  sex: string;
  /** 身份证卡号 */
  number: string;
  /** 姓名 */
  name: string;
  /** 生日，timestamp */
  birth: string;
  /** 地址 */
  address: string;
  /** log.id 基建后端用于log分析 */
  frontTransactionId: string;
}

export interface NativeOCRBack {
  /** 有效期开始时间 ios返回时间戳，Android返回YYYYMMDD */
  startDate: string;
  /** 有效期结束时间 ios返回时间戳，Android返回YYYYMMDD */
  endDate: string;
  /** 所属公安局 */
  authority: string;
  /** log.id 基建后端用于log分析 */
  backTransactionId: string;
}

export interface NativeSignVo {
  token: string;
  sceneType: string;
  aliPayReturnUrl: string;
  businessType: string;
  signChannel: string;
  actionOrigin: string;
  creditModel?: string;
  memo?: string;
}

// 通讯录联系人字段信息
export interface ContractInfo {
  // ios
  firstName: string;
  lastName: string;
  org: string;
  // android
  name: string;
  company: string;
  jobTitle: string;
  // common
  phones: string[];
}

export interface DirectItemShareInfo {
  title: string; // 标题
  tapType: number; // 分享渠道
  desc?: string; // 描述
  imageUrl?: string; // 分享图片地址
  shareImageUrl?: string; // 分享缩略图
  shareUrl?: string; // 分享出去的链接
  qrShareBg?: string; // 分享背景图片地址
  content?: string; // 分享内容
}

export interface SignApply {
  preOrderInfo: string;
  channelCode?: string;
  businessType: string;
}

// 支付宝小程序活体识别返回数据结果
export type AliminiFaceAuthResult = Dictionary & {
  transactionId: string | number
};

export interface AlipayMiniOptionsType {
  count?: number; // [count=1] - 最大可选照片数
  sizeType?: string[]; // [sizeType=['original', 'compressed']] - original: 原图; compressed: 压缩图
  sourceType?: string[]; // [sourceType=[‘camera’,‘album’]] - 相册选取或者拍照
  success?: () => void; // 调用成功的回调函数
  fail?: () => void; // 调用失败的回调函数
  complete?: () => void; // 调用结束的回调函数（调用成功、失败都会执行）
}

// 字段定义 https://hellobike.yuque.com/gqiz6x/amhg34/fegotc
export interface uploadFileOptionsTypes {
  image: number;// 图片存储目录 目前数科 用 75
  type: number;// 上传类型
}

export enum uploadFileOptionsTypeEnum {
  ANDROID = 1, // Android客户端
  IOS = 2, // iOS客户端
  WEB = 3, // 网页h5
  MINIPRO_WECHAT = 4, // 微信小程序
  MINIPRO_ALIPAY = 5, // 支付宝小程序
}

/** 腾讯OCRSDK签名类型 */
export interface TencentSDKSignTypes {
  appId: string;
  nonceStr: string;
  signature: string;
  ticket: string;
  version: string;
  /** 用户的userId */
  userId: string;
  /** 订单号，可用于供应商问题链路排查 */
  orderNo: string;
}

/** setStatusBarColor安卓状态栏native方法参数 */
export interface SetStatusBarColorParams {
  /** 是否显示状态栏 */
  isShowStatusBar: boolean;
  /** 状态栏是否设置黑字 */
  isDarkFont?: boolean;
  /** 状态栏颜色代码 */
  colorCode?: string;
}

/**
  * 检查联系人权限状态枚举
  * 0-未知, 1-未决定（用户尚未选择是否授权）, 2-已授权, 3-已拒绝, 4-受限制（（设备限制，如家长控制） 5-华为机型数据管控
  */
export enum ContactPermissionStatusEnum {
  UNKNOWN = 0,
  UNDECIDED = 1,
  AUTHORIZED = 2,
  REJECTED = 3,
  RESTRICTED = 4,
  DATA_CONTROL = 5,
}

/**
 *  返回的权限状态
 */
export interface ContactPermissionStatus {
    status: ContactPermissionStatusEnum;
}

/**
 * 返回的联系人信息
 */
export interface ContactInfoResponse {
  /** 是否成功 */
  success: boolean;
  /** 权限状态 */
  status: ContactPermissionStatusEnum;
  /** 联系人信息（成功时包含） */
  contactInfo?: {
    /** 名 */
    givenName?: string;
    /** 姓 */
    familyName?: string;
    /** 全名 */
    fullName?: string;
    /** 联系人手机号 */
    phoneNumber?: string;
    /** 电话号码标签（如：手机、工作、家庭等） */
    phoneLabel?: string;
  };
  /** 错误信息（失败时包含） */
  errorMessage?: string;
}


/**
 * 联系人信息
 */
export interface ContactDetails {
  name: string;
  phone: string;
}

/**
 * selectContact 返回结果（包含状态和联系人信息）
 */
export interface SelectContactResult {
  /** 权限状态 */
  status?: ContactPermissionStatusEnum;
  /** 联系人信息（当状态为已授权时才有） */
  contactInfo?: ContactDetails;
}
